import React, {useState, useEffect} from "react";
import Subscribe from "./Subscribe";
import Head from "next/head";
import {
  WealthyValidations,
  WealthyEnv,
  triggerToast,
  handleApiError
} from "helpers";
import {requestSubscription} from "api";

const recaptchaTokenUrl = `https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_TOKEN}`;

const SubscribeContainer = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    initCaptcha();
    const interval = setInterval(() => {
      initCaptcha();
    }, 1000 * 60 * 5);
    return () => clearInterval(interval);
  }, []);

  const subscribeInputHandler = (e) => {
    setEmail(e.currentTarget.value);
  };

  const submitSubscribe = (e) => {
    e.preventDefault();

    const emailCheck = WealthyValidations.validateFormField.email(email);

    if (!emailCheck) {
      triggerToast("Please enter a valid email ID");
    } else {
      requestSubscription({email, token})
        .then(res => {
          setSuccess(true);
          if (window?.analytics) {
            window?.analytics.track("Subscription requested", {
              category: "Money Order",
              label: "Subscription"
            });
          } else {
            console.log("analytics not set, analytics not available");
          }
        })
        .catch(error => console.log(error));
    }
  };

  const initCaptcha = () => {
    window?.grecaptcha?.ready(function () {
      window?.grecaptcha?.execute(`${WealthyEnv.RECAPTCHA_TOKEN}`, {action: "homepage"}).then(function (token) {
        setToken(token);
      });
    });
  };

  return (
    <>
      <Head>
        <script src={recaptchaTokenUrl} />
      </Head>
      <Subscribe
        email={email}
        submitSubscribe={submitSubscribe}
        subscribeInputHandler={subscribeInputHandler}
        success={success}
      />
    </>
  );
};

export default SubscribeContainer;
